/**
 * NOS-257: the SPA's entry point to the ONE subdomain rule set.
 *
 * The rules themselves (reserved list, 6–30 length, regex, grandfather
 * allowlist) are canonical in `@nos/host-resolution` — kept zero-import there
 * so the edge middleware, Astro app, and Deno functions share them. This
 * module re-exports them and adds the supabase-backed availability check
 * used by the create and rename paths.
 */

import { supabase } from "@/lib/supabase"

export {
  GRANDFATHERED_SLUGS,
  RESERVED_SUBDOMAINS,
  SUBDOMAIN_MAX_LENGTH,
  SUBDOMAIN_MIN_LENGTH,
  SUBDOMAIN_REGEX,
  validateSubdomain,
  type SubdomainValidation,
} from "../../packages/host-resolution/src/index.ts"

/**
 * True when no org holds this slug. Pass `excludeOrgId` on rename so the
 * org's own current slug counts as available.
 */
export async function checkSubdomainAvailability(
  subdomain: string,
  excludeOrgId?: string
): Promise<boolean> {
  const normalized = subdomain.trim().toLowerCase()
  const { data, error } = await supabase
    .from("organizations")
    .select("id")
    .eq("slug", normalized)
    .maybeSingle()
  if (error) return false
  if (data === null) return true
  return excludeOrgId !== undefined && data.id === excludeOrgId
}
